/**
 * @desc WMS销售自营仓退件签收
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutReturnSignRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/returnSigning`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
